import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900/50 backdrop-blur-xl border-t border-gray-800/50">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
              ViralVoice AI
            </h3>
            <p className="mt-4 text-gray-400 max-w-md">
              Empowering creators with AI-driven social media engagement and voice cloning technology.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-gray-400 hover:text-white transition">Features</a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-white transition">Pricing</a>
              </li>
              <li>
                <Link to="/affiliate" className="text-gray-400 hover:text-white transition">Affiliate Program</Link>
              </li>
              <li>
                <Link to="/signup" className="text-gray-400 hover:text-white transition">Sign Up</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800/50">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} ViralVoice AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 